import React, { useEffect, useState } from 'react';
import TextPage from "../text-page";
import Api from '../../services';
import withHeaderAndFooter from '../with-header-and-footer-hoc';

const PaymentDelivery = () => {

    const [content, setContent] = useState({});

    useEffect(() => {
        Api.text_page.getDelivery()
            .then(response => setContent(response.data))
    }, []);



    return(
        <>
            <TextPage content={content} />
        </>
    );
}

export default withHeaderAndFooter(PaymentDelivery);